import React from "react";

import Layout from "../components/layout";

const PrivacyPolicyPage = () => (
  <Layout>
    <div className="container mt-5">
      <div className="row">
        <div className="col">
          <h1 className="font-weight-bold">End-User License Agreement ("Agreement")</h1>

          <p>Last updated: June 08, 2019</p>

          <p className="pt-3">
            Please read this End-User License Agreement ("Agreement") carefully
            before clicking the "I Agree" button, downloading or using Tramo
            ("Application").
          </p>

          <p>
            By clicking the "I Agree" button, downloading or using the
            Application, you are agreeing to be bound by the terms and
            conditions of this Agreement.
          </p>

          <p>
            This Agreement is a legal agreement between you (either an
            individual or a single entity) and Tramo and it governs your use of
            the Application made available to you by Tramo.
          </p>

          <p>
            If you do not agree to the terms of this Agreement, do not click on
            the "I Agree" button and do not download or use the Application.
          </p>

          <p>
            The Application is licensed, not sold, to you by Tramo for use
            strictly in accordance with the terms of this Agreement. This EULA
            for Tramo has been created with the help of{" "}
            <a href="https://www.termsfeed.com/">TermsFeed</a>.
          </p>

          <h2 className="font-weight-bold pt-3">License</h2>

          <p className="pt-3">
            Tramo grants you a revocable, non-exclusive, non-transferable,
            limited license to download, install and use the Application solely
            for your personal, non-commercial purposes strictly in accordance
            with the terms of this Agreement.
          </p>

          <h2 className="font-weight-bold pt-3">Third-Party Services</h2>

          <p className="pt-3">
            The Application may display, include or make available third-party
            content (including data, information, applications and other
            products services) or provide links to third-party websites or
            services ("Third-Party Services").
          </p>

          <p>
            You acknowledge and agree that Tramo shall not be responsible for
            any Third-Party Services, including their accuracy, completeness,
            timeliness, validity, copyright compliance, legality, decency,
            quality or any other aspect thereof. Tramo does not assume and shall
            not have any liability or responsibility to you or any other person
            or entity for any Third-Party Services.
          </p>

          <p>
            Third-Party Services and links thereto are provided solely as a
            convenience to you and you access and use them entirely at your own
            risk and subject to such third parties' terms and conditions.
          </p>

          <h2 className="font-weight-bold pt-3">Term and Termination</h2>

          <p className="pt-3">
            This Agreement shall remain in effect until terminated by you or
            Tramo.
          </p>

          <p>
            Tramo may, in its sole discretion, at any time and for any or no
            reason, suspend or terminate this Agreement with or without prior
            notice.
          </p>

          <p>
            This Agreement will terminate immediately, without prior notice from
            Tramo, in the event that you fail to comply with any provision of
            this Agreement. You may also terminate this Agreement by deleting
            the Application and all copies thereof from your mobile device or
            from your computer.
          </p>

          <p>
            Upon termination of this Agreement, you shall cease all use of the
            Application and delete all copies of the Application from your
            mobile device or from your computer.
          </p>

          <p>
            Termination of this Agreement will not limit any of Tramo's rights
            or remedies at law or in equity in case of breach by you (during the
            term of this Agreement) of any of your obligations under the present
            Agreement.
          </p>

          <h2 className="font-weight-bold pt-3">Amendments to this Agreement</h2>

          <p className="pt-3">
            Tramo reserves the right, at its sole discretion, to modify or
            replace this Agreement at any time. If a revision is material we
            will provide at least 30 days' notice prior to any new terms taking
            effect. What constitutes a material change will be determined at our
            sole discretion.
          </p>

          <p>
            By continuing to access or use our Application after any revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, you are no longer authorized to use
            the Application.
          </p>

          <h2 className="font-weight-bold pt-3">Governing Law</h2>

          <p className="pt-3">
            The laws of Ukraine, excluding its conflicts of law rules, shall
            govern this Agreement and your use of the Application. Your use of
            the Application may also be subject to other local, state, national,
            or international laws.
          </p>

          <h2 className="font-weight-bold pt-3">Contact Information</h2>

          <p className="pt-3">
            If you have any questions about this Agreement, please contact us.
          </p>

          <h2 className="font-weight-bold pt-3">Entire Agreement</h2>

          <p className="pt-3">
            The Agreement constitutes the entire agreement between you and Tramo
            regarding your use of the Application and supersedes all prior and
            contemporaneous written or oral agreements between you and Tramo.
          </p>

          <p>
            You may be subject to additional terms and conditions that apply
            when you use or purchase other Tramo's services, which Tramo will
            provide to you at the time of such use or purchase.
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

export default PrivacyPolicyPage;
